import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="d-flex justify-content-end pe-3 pt-2 pb-0 mt-2">
        <p className="dark-text">
          Techuiastic &copy; 2022 -{" "}
          <span>
            <a href="https://github.com/J0shcodes">J0shcodes</a>
          </span>
        </p>
      </footer>
    </>
  );
};

export default Footer;
